import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { getCmsContent_action } from "../../../actions/cms_action/cmsAction";
import { toastError } from "../../../utils/constants";

class StaticHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_id: sessionStorage.getItem("user_id"),
            role_id: sessionStorage.getItem("role_id"),
            headerNavs: [], cmsMode: ''
        };
    }
    componentDidMount() {
        // Scroll listener
        this.handleScroll = () => {
            this.setState({ scrollPosition: window.scrollY });
        };
        console.log(this.props.headerNavs, 'headerNavs')
        if (Array.isArray(this.props.headerNavs) && this.props.headerNavs.length > 0) {
            this.setState({ headerNavs: this.props.headerNavs })
        } else {
            console.log('else header')
            this.getCmsContent(1, 'home');
        }
        const path = this.props.location.pathname;
        const cmsPrefix = '/cms';
        if (path.includes(cmsPrefix)) {
            console.log(path, 'cmspath')
            this.setState({ cmsMode: 1 })
        } else {
            this.setState({ cmsMode: 0 })
        }

    }
    getCmsContent = async (MenuID, MenuUrl) => {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    headerNavs: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5] !== "" ? data?.data[5] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    navigateDashboard() {
        const role_id = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"))?.role_id;
        if (role_id == 1) {
            this.props.navigate('/adminDashboard');
        } else if (role_id == 2) {
            this.props.navigate('/juryDashboard');
        } else if (role_id == 3) {
            this.props.navigate('/adminDashboard');
        } else if (role_id == 4) {
            this.props.navigate('/applicantDashboard');
        }
    }

    OnLogOut() {
        sessionStorage.clear();
        this.props.navigate('/');
    }

    onClickLoginSignUp() {
        sessionStorage.removeItem("award_event_profile_id");
        this.props.navigate('/signUp');
    }
    handleMenuClick(MenuID, Url) {
        sessionStorage.setItem("MenuID", MenuID);
        sessionStorage.setItem("Url", Url);

        const trimmedUrl = Url.trim();
        const externalUrlPattern = /^(https?:\/\/|www\.|ftp:\/\/|mailto:)/i;

        if (externalUrlPattern.test(trimmedUrl)) {
            window.open(trimmedUrl, '_blank');
        } else {
            const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl : '/' + trimmedUrl;
            const basePath = this.props.location.pathname.includes('/cms') ? '/cms/manage' : '';
            const newPath = `${basePath}${normalizedUrl}&${MenuID}`

            this.props.navigate(newPath);
        }
    }


    render() {
        const { headerNavs, cmsMode, cmsSubheaderData } = this.state;
        const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
        const name = userLoginData ? userLoginData.user_name : '';
        const EmailId = userLoginData ? userLoginData.email_address : '';
        const mobileNo = userLoginData ? userLoginData.contact_no : '';

        // Step 1: Filter active and published items
        const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish);

        // Step 2: Separate parents and children
        const parents = filteredNavs?.filter(item => item.ParentID === null);
        const childrenMap = {};

        filteredNavs?.forEach(item => {
            if (item.ParentID !== null) {
                if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                childrenMap[item.ParentID].push(item);
            }
        });
        return (
            <>
                <div className="website">
                    <marquee style={{ fontSize: "16px", color: "#000", fontWeight: "500"}}
                        behavior="scroll" direction="left" scrollamount="5"
                        onMouseOver={(e) => e.target.stop()}
                        onMouseOut={(e) => e.target.start()}>
                        <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                    </marquee>
                    <header className="main_header_area position-fixed w-100">
                        <div className="header-content text-white">
                            <div className="container-fluid header-padding py-2">
                                <div className="header-content-inner">
                                    <div className="row align-items-center">
                                        <div className="col-lg-4">
                                            <div className="header-event-info ">
                                                <div className="social-links">
                                                    <ul className="m-0 p-0">
                                                        <li className="d-inline mx-2">
                                                            <span>Follow us on:</span>
                                                        </li>
                                                        <li className="d-inline">
                                                            <a target="_blank" href="https://www.facebook.com/indiaitmesociety">
                                                                <i className="fa fa-facebook border-social rounded-circle text-center" />
                                                            </a>
                                                        </li>
                                                        <li className="d-inline">
                                                            <a target="_blank" href="https://x.com/India_ITME">
                                                                <i className="fa fa-twitter border-social rounded-circle text-center" />
                                                            </a>
                                                        </li>
                                                        <li className="d-inline">
                                                            <a target="_blank" href="https://www.instagram.com/indiaitme/">
                                                                <i className="fa fa-instagram border-social rounded-circle text-center" />
                                                            </a>
                                                        </li>
                                                        <li className="d-inline">
                                                            <a target="_blank" href="https://www.linkedin.com/company/india-itme?trk=biz-companies-cym">
                                                                <i className="fa fa-linkedin border-social rounded-circle text-center" />
                                                            </a>
                                                        </li>
                                                        <li className="d-inline">
                                                            <a target="_blank" href="https://www.youtube.com/c/IndiaITMESociety">
                                                                <i className="fa fa-youtube-play border-social rounded-circle text-center" />
                                                            </a>
                                                        </li>
                                                        <li className="d-inline">
                                                            <a target="_blank" href="skype:indiaitme2012?call">
                                                                <i className="fa fa-skype border-social rounded-circle text-center" />
                                                            </a>
                                                        </li>
                                                        {/* <li className="d-inline">
                                                            <a target="_blank" href="https://awards.india-itme.com/static/images/Reg-form.mp4" >
                                                                <img src='../static/images/demoVideoIcon.png' width={35} />
                                                            </a>
                                                        </li> */}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="header_menu " id="header_menu">
                            <nav className="navbar navbar-expand-lg navbar-light bg-light p-0">
                                <div className="container-fluid header-padding">
                                    <div className="d-flex">
                                        <a className="navbar-brand p-0 m-0">
                                            <Link to='/'>
                                                <img src="../static/images/logo.png" alt="Logo" className="logo-img" style={{ width: 150, margin: "6px 0px" }} />
                                            </Link>
                                        </a>
                                        <button
                                            className="navbar-toggler border-0"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#navbarResponsive"
                                            aria-controls="navbarResponsive"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            style={{ outline: 'none' }}
                                        >
                                            <span className="navbar-toggler-icon" />
                                        </button>
                                    </div>
                                    {/* Navigation Menu */}

                                    <div className="collapse navbar-collapse" id="navbarResponsive">
                                        {userLoginData != null &&
                                            <ul style={{ paddingTop: "0px", width: '100%' }} className="website-mobile-view">
                                                <li className="nav-item name_li"><a className="nav-link"><p className="nameClass">
                                                    {name}<br />
                                                    {EmailId}<br />
                                                    {mobileNo}{mobileNo != '' && mobileNo != null && <br />}
                                                </p></a>
                                                </li>
                                            </ul>}
                                        <ul className="navbar-nav me-auto mb-0 mb-lg-0">
                                            {(() => {
                                                const visibleParents = parents?.filter(parent =>
                                                    parent.isMenuItem || (childrenMap[parent.MenuID]?.some(child => child.isMenuItem))
                                                );
                                                const internalPages = cmsMode
                                                    ? [...parents?.filter(parent => !parent.isMenuItem).map(parent => ({
                                                        ...parent, isParent: true
                                                    })) || [],
                                                    ...Object.values(childrenMap).flat().filter(child => !child.isMenuItem)
                                                    ] : [];

                                                const showInternalPages = cmsMode && internalPages && internalPages.length > 0;

                                                return (
                                                    <>
                                                        {visibleParents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent) => {
                                                            console.log(visibleParents, 'parentsss')
                                                            const validChildren = childrenMap[parent.MenuID]?.filter(child => child.isMenuItem);
                                                            const hasChildren = validChildren?.length > 0;

                                                            if (parent.isMenuItem ? parent.isMenuItem : hasChildren) {
                                                                if (hasChildren) {
                                                                    return (
                                                                        <li key={parent.MenuID} className="nav-item menu-font dropdown">
                                                                            <a
                                                                                className="nav-link dropdown-toggle px-2 my-4 py-0 text-dark"
                                                                                role="button"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <span className={this.props.location.pathname === parent.Url ? "active" : ""}>
                                                                                    {parent.Title} <i className="fa fa-angle-down" aria-hidden="true"></i>
                                                                                </span>
                                                                            </a>
                                                                            <ul className="dropdown-menu bg-lightgrey top-nav p-0 rounded">
                                                                                {validChildren?.sort((a, b) => a.Sequence - b.Sequence)?.map(child => (
                                                                                    <li key={child.MenuID}>
                                                                                        <a className="dropdown-item py-2 px-6 text-capitalize black border-0"
                                                                                            onClick={() => this.handleMenuClick(child.MenuID, child.Url)}>
                                                                                            {child.Title}
                                                                                        </a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </li>
                                                                    );
                                                                }

                                                                // Single visible item
                                                                return (
                                                                    <li key={parent.MenuID} className="nav-item menu-font">
                                                                        <a className="nav-link px-2 my-4 py-0 text-dark"
                                                                            onClick={() => this.handleMenuClick(parent.MenuID, parent.Url)}>
                                                                            <span className={this.props.location.pathname === parent.Url ? "active" : ""}>
                                                                                {parent.Title}
                                                                            </span>
                                                                        </a>
                                                                    </li>
                                                                );
                                                            }

                                                            return null; // Do not render anything if parent is not visible
                                                        })}
                                                        {showInternalPages ? (
                                                            <li className="nav-item menu-font dropdown">
                                                                <a
                                                                    className="nav-link dropdown-toggle px-2 my-4 py-0 text-dark"
                                                                    role="button"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <span>Internal Pages <i className="fa fa-angle-down" aria-hidden="true"></i></span>
                                                                </a>
                                                                <ul className="dropdown-menu bg-lightgrey top-nav p-0 rounded">
                                                                    {internalPages?.sort((a, b) => a.Sequence - b.Sequence)?.map(child => (
                                                                        <li key={child.MenuID}>
                                                                            <a className="dropdown-item py-2 px-6 text-capitalize black border-0"
                                                                                onClick={() => this.handleMenuClick(child.MenuID, child.Url)}>
                                                                                {child.Title}
                                                                            </a>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </li>
                                                        ) : <></>}
                                                    </>
                                                );
                                            })()}

                                            {/* Keep the last item (Config Header for Admin) as is */}
                                            {JSON.parse(sessionStorage.getItem("AwardsUserLoginData"))?.role_id == 1 && (
                                                <>
                                                    <li className="nav-item menu-font dropdown">
                                                        <a
                                                            className="nav-link dropdown-toggle px-2 my-4 py-0 text-dark"
                                                            role="button"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <span className={this.props.location.pathname.includes('/cms') ? "active" : ""}>
                                                                CMS <i className="fa fa-angle-down" aria-hidden="true"></i>
                                                            </span>
                                                        </a>
                                                        <ul className="dropdown-menu bg-lightgrey top-nav p-0 rounded">
                                                            <Link to="/cms/manage">
                                                                <li className="nav-item menu-font">
                                                                    <a className="dropdown-item py-2 px-6 text-capitalize black border-0">
                                                                        <span className={this.props.location.pathname === "/cms/manage" ? "active" : ""}>Switch to Editor Mode</span>
                                                                    </a>
                                                                </li>
                                                            </Link>
                                                            <Link to="/cms/header">
                                                                <li className="nav-item menu-font">
                                                                    <a className="dropdown-item py-2 px-6 text-capitalize black border-0">
                                                                        <span className={this.props.location.pathname === "/cms/header" ? "active" : ""}>Menu Settings</span>
                                                                    </a>
                                                                </li>
                                                            </Link>
                                                        </ul>
                                                    </li>

                                                </>
                                            )}
                                        </ul>

                                        {userLoginData != null ?
                                            <>
                                                <div className="govt_logo text-end mb-2 d-flex justify-content-end align-items-center">
                                                    Supported By:
                                                    <img src="../static/images/Office_of_textile_Commissioner_Ministry_of_Textile_Logo.jpg" alt="Logo" className="logo-img" style={{ width: 60, margin: "6px" }} />
                                                    <img src="https://awards.india-itme.com/document/Static/1/DHI_logo.png" alt="Logo" className="logo-img" style={{ width: 60, margin: "6px" }} />
                                                    Powered By:
                                                    <img src="https://awards.india-itme.com/document/Static/1/sbi_logo.jpeg" alt="Logo" className="logo-img" style={{ width: 60, margin: "6px" }} />
                                                </div>
                                                <a className="btn btn3 mx-1 mb-2 mt-2"
                                                    style={{ padding: '7px 13px' }}
                                                    onClick={() => this.navigateDashboard()}>
                                                    Dashboard
                                                </a>
                                                <a className="btn btn3 mb-2 mt-2 website-mobile-view"
                                                    style={{ padding: '7px 13px' }}
                                                    onClick={() => this.OnLogOut()}>
                                                    Log Out
                                                </a>
                                                <nav className="nav-menu d-none d-lg-block float-right">
                                                    <ul>
                                                        <li className="drop-down profile_li">
                                                            <div className="user-icon ps" style={{ cursor: 'pointer' }}>
                                                                {sessionStorage.getItem('user_name')
                                                                    .split(" ").map((word) => word[0]).join("").toUpperCase()}
                                                            </div>

                                                            <ul style={{ paddingTop: "0px", display: '' }}>
                                                                <li className="nav-item name_li"><a className="nav-link">
                                                                    <p className="nameClass">
                                                                        {name}<br />
                                                                        {EmailId}<br />
                                                                        {mobileNo}{mobileNo != '' && mobileNo != null && <br />}
                                                                    </p>
                                                                </a>
                                                                </li>
                                                                <li onClick={() => this.OnLogOut()} className="nav-item">
                                                                    <a style={{ cursor: "pointer", color: "red" }} className="nav-link">Logout</a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </>
                                            :
                                            <>
                                                <div className="govt_logo text-end mb-2 d-flex justify-content-end align-items-center">
                                                    Supported By:
                                                    <img src="../static/images/Office_of_textile_Commissioner_Ministry_of_Textile_Logo.jpg" alt="Logo" className="logo-img" style={{ width: 60, margin: "6px" }} />
                                                    <img src="https://awards.india-itme.com/document/Static/1/DHI_logo.png" alt="Logo" className="logo-img" style={{ width: 60, margin: "6px" }} />
                                                    Powered By:
                                                    <img src="https://awards.india-itme.com/document/Static/1/sbi_logo.jpeg" alt="Logo" className="logo-img" style={{ width: 60, margin: "6px" }} />
                                                </div>
                                                <a className="btn btn3"
                                                    style={{ padding: '7px 13px', marginLeft: '10px' }}
                                                    onClick={() => this.onClickLoginSignUp()}>
                                                    Sign In
                                                </a>
                                            </>
                                        }
                                    </div>
                                </div>
                            </nav>

                            <div id="search1">
                                <button type="button" className="close">
                                    ×
                                </button>
                                <form>
                                    <input className="form-control form-control-lg rounded text-white" placeholder="Search..." />
                                </form>
                                <button type="button" className="btn">
                                    <i className="fa fa-search text-white" />
                                </button>
                            </div>
                        </div>
                    </header>
                </div>
            </>
        );
    }
}
export default withRouter(
    connect(null, { getCmsContent_action })(StaticHeader)
);
